export const SET_SELECTED_SIZE_ITEM = "SET_SELECTED_SIZE_ITEM"
export const SHOW_SIZE_PICKER = "SHOW_SIZE_PICKER"
export const CLOSE_SIZE_PICKER = "CLOSE_SIZE_PICKER"
export const SET_IS_VISIBLE = "SET_IS_VISIBLE"
export const SET_SIZE_PICKER_OPTIONS = "SET_SIZE_PICKER_OPTIONS";

export const setSizePickerRenderFunction = renderFunction => ({
    type: SHOW_SIZE_PICKER,
    payload: {
        renderFunction
    }
})

export const showSizePicker = () => ({
    type: SHOW_SIZE_PICKER,
    payload: {
        visible: true,
        shouldClose: false
    }
})

export const closeSizePicker = () => ({
    type: CLOSE_SIZE_PICKER,
    payload: {
        shouldClose: true
    }
})

export const setIsVisible = visible => ({
    type: SET_IS_VISIBLE,
    payload: {
        visible: visible
    }
})

export const setSizePickerOptions = options => ({
    type: SET_SIZE_PICKER_OPTIONS,
    payload: options
})

export const setSelectedSizeItem = sizeItem => ({
    type: SET_SELECTED_SIZE_ITEM,
    payload: {
        selectedSizeItem: sizeItem
    }
})

export const setSelectedSizeByName = size => (dispatch, getState) => {
    const sizes = getState().sizePicker.sizes
    var selectedSizeItem = sizes.find(s => s.size.toLowerCase() == size.toLowerCase())
    if (selectedSizeItem && selectedSizeItem.isInStock) {
        dispatch(setSelectedSizeItem(selectedSizeItem))
    }
}